/* (ignored) */


//////////////////
// WEBPACK FOOTER
// ../locale-data/index.js (ignored)
// module id = 636
// module chunks = 0